import { lsGetItem } from './functions'

// default published languages
const availableLangs = [
  { code: 'en', text: 'English' },
  { code: 'es', text: 'Español - Spanish' }
]

// default state
const state = {
  appInit: false,
  appReady: false,
  appStep: 1,
  appDefaultTitle: '<span class="up">ASD</span><span class="low">etect</span>',
  appToolbarTitle: '',
  snackbarQueue: [],
  userToken: lsGetItem('userToken'),
  userObject: lsGetItem('userObject'),
  userChildren: [],
  assessments: {},
  availableLangs,
  appDefaultLang: 'en',
  userSelectedLang: lsGetItem('userSelectedLang')
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js